import { useStore } from '@nanostores/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PrivateBetaScreen } from './PrivateBetaScreen';
import { AuthManager } from '~/components/ui/shadcn/components/supabase-manager/Auth.client';
import { NoDatabaseScreen } from '~/components/ui/shadcn/components/supabase-manager/NoDatabaseScreen';
import { supabaseStore } from '~/lib/stores/supabase';
import { userStore } from '~/lib/stores/user';

const queryClient = new QueryClient();

export const Authentication = () => {
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);
  const featureFlags = useStore(userStore.featureFlags);
  const project = useStore(supabaseStore.supabaseProject);
  const projectId = project?.id;

  if (!featureFlags.supabaseManagement) {
    return (
      <PrivateBetaScreen
        icon="i-heroicons:shield-check"
        title="Secure your application"
        description="Configure sign-in methods, set up OAuth providers, and manage authentication settings for your users."
      />
    );
  }

  if (supabaseStatus !== 'CONFIGURED' || !projectId) {
    return (
      <NoDatabaseScreen
        icon="i-heroicons:shield-check"
        description="You need a database to manage authentication settings for your users directly from your project settings."
      />
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AuthManager />
    </QueryClientProvider>
  );
};
